module.exports = __webpack_public_path__ + "img/cerrar_filtro_catalogo.6c412673.svg";